// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

import emailValidator from "./validators/email";
import fileValidator from "./validators/file";
import fioValidator from "./validators/fio";
import humanDateValidator from "./validators/human-date";
import idNumberLocationZaValidator from "./validators/id-number-location-za";
// Components
import imeiValidator from "./validators/imei";
import innValidator from "./validators/inn";
import nameValidation from "./validators/name";
import phoneValidator from "./validators/phone";
import serialValidator from "./validators/serial";

interface I_UseValidate_Params {
    target:
        | "name"
        | "imei"
        | "serial"
        | "fio"
        | "inn"
        | "email"
        | "phone"
        | "file"
        | "human-date"
        | "id-number--location-za";
    value: string | HTMLInputElement;
}

export interface I_UseValidate_Return {
    status: boolean;
    message: string;
}

/** Верхнеуровневая функция-валидатор */
export default function useValidate({ target, value }: I_UseValidate_Params): I_UseValidate_Return {
    switch (target) {
        case "name": {
            return nameValidation(value as string);
        }
        case "imei": {
            return imeiValidator(value as string);
        }
        case "serial": {
            return serialValidator(value as string);
        }
        case "file": {
            return fileValidator(value as HTMLInputElement);
        }
        case "fio": {
            return fioValidator(value as string);
        }
        case "inn": {
            return innValidator(value as string);
        }
        case "email": {
            return emailValidator(value as string);
        }
        case "phone": {
            return phoneValidator(value as string);
        }
        case "human-date": {
            return humanDateValidator(value as string);
        }
        case "id-number--location-za": {
            return idNumberLocationZaValidator(value as string);
        }
        default:
            return {
                status: false,
                message: useTranslate("tiw__validation__undefined"),
            };
    }
}
